import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { spacing, palette } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import Button from '../../Button/Button.es.js';
import { Box } from '../../../primitives/Box/Box.es.js';

const ListItem = styled(Button)`
    padding: 0 ${spacing("lg")};
    button {
        flex-shrink: 0;
    }
    .highlight {
        background: ${palette("primary.500", 0.24)};
    }
`;
const SubItemsWrapper = styled.div`
    > li > button {
        padding: 0 ${spacing("jb")};
    }
`;
const ListFilterWrapper = styled.div`
    width: 320px;
    ${({ theme }) => theme.breakpoint("md")`
        width: 100%;
    `}
`;
const ListItemsScrollContainer = styled(Box)`
    height: 314px;
    overflow: auto;
    ${({ theme }) => theme.breakpoint("md")`
        height: 100%;
    `}
    ${(props) => `
        height: ${props.height};
    `};
`;
const ListItemsItem = styled.li`
    display: flex;
    justify-content: center;
    cursor: pointer;
    button {
        border-radius: 0;
        div {
            transition: all 0ms;
        }
    }
    :hover {
        background-color: ${palette("neutral.700", 1)};
        button,
        div {
            background-color: ${palette("neutral.700", 1)};
        }
    }
`;
const CaretDownWrapper = styled(Box)`
    color: ${palette("neutral.400", 1)};
    :hover {
        color: ${palette("neutral.50")};
    }
    ${({ areSubItemsVisible }) => areSubItemsVisible && `
        svg {
            transform: rotate(180deg);
        }
    `}
`;

export { CaretDownWrapper, ListFilterWrapper, ListItem, ListItemsItem, ListItemsScrollContainer, SubItemsWrapper };
//# sourceMappingURL=ListFilter.es.js.map
